export enum Color {
	PrimaryBlue = '#0047BB',
	PrimaryBlue77 = '#8AB6FF',
	PrimaryBlue87 = '#BDD6FF',
	PrimaryBlue97 = '#E0ECFF',
	PrimaryBlue17 = '#002157',
	SecondaryBlue1 = '#00205B',
	OnPrimarySurface = '#FCFCFC',
	PrimaryBlueDark = '#00348A',
	OnBackgroundText = '#000E29',
	SecondaryGreen2 = '#78D64B',
	SecondaryGreen227 = '#36701A',
	SecondaryGreen287 = '#D6F3C9',
	OnSecondaryGreen2 = '#224710',
	Error = '#FC3D21',
	Error16 = '#510B01',
	Error46 = '#E72003',
	Error76 = '#FD9586',
	Error96 = '#FEDBD7',
	OxdBackground = '#F8E7E7',
	OxdPrimary = '#BD3436',
	PrimaryWhite = '#FFFFFF',
	Neutral30 = '#4D4D4D',
	Neutral40 = '#666',
	Neutral50 = '#808080',
	Neutral70 = '#B3B3B3',
	Neutral80 = '#CCCCCC',
	Neutral92 = '#EBEBEB',
	Neutral94 = '#F0F0F0',
	Success40 = '#66AF1D',
	Tertiary97 = '#FAFBDA',
}
